"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentDetailsFieldsOrder = void 0;
const getPaymentDetailsFieldsOrder = (countryCode) => {
    return PAYMENT_DETAILS_FIELDS_ORDER[countryCode] || PAYMENT_DETAILS_FIELDS_ORDER.default;
};
exports.getPaymentDetailsFieldsOrder = getPaymentDetailsFieldsOrder;
const PAYMENT_DETAILS_FIELDS_ORDER = {
    default: [
        'fake',
        'issuerBank',
        'holderId',
        'email',
        'firstName',
        'lastName',
        'street',
        'houseNumber',
        'address',
        'city',
        'countryCode',
        'state',
        'zipCode',
        'phone',
    ],
    jpn: [
        'fake',
        'issuerBank',
        'holderId',
        'email',
        'lastName',
        'firstName',
        'countryCode',
        'zipCode',
        'state',
        'city',
        'address',
        'street',
        'houseNumber',
        'phone',
    ],
    deu: [
        'fake',
        'issuerBank',
        'holderId',
        'firstName',
        'lastName',
        'email',
        'street',
        'houseNumber',
        'address',
        'zipCode',
        'city',
        'countryCode',
        'state',
        'phone',
    ],
    kor: [
        'fake',
        'issuerBank',
        'holderId',
        'email',
        'lastName',
        'firstName',
        'street',
        'houseNumber',
        'countryCode',
        'zipCode',
        'state',
        'city',
        'address',
        'phone',
    ],
    aus: [
        'fake',
        'issuerBank',
        'holderId',
        'firstName',
        'lastName',
        'email',
        'street',
        'houseNumber',
        'address',
        'city',
        'countryCode',
        'state',
        'zipCode',
        'phone',
    ],
    bra: [
        'fake',
        'issuerBank',
        'countryCode',
        'email',
        'firstName',
        'lastName',
        'holderId', // 'CPF/CNPJ'
        'zipCode',
        'address',
        'city',
        'state',
        'street',
        'houseNumber',
        'phone',
    ],
};
//# sourceMappingURL=getPaymentDetailsFieldsOrder.js.map